import { render } from "./CourseGroupCapacity.vue?vue&type=template&id=9cf43b86&ts=true"
import script from "./CourseGroupCapacity.vue?vue&type=script&lang=ts"
export * from "./CourseGroupCapacity.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__